import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { ConnectedAccountFunds } from './connected-account.funds.entity';

export class CreateConnectedAccountFundsDto extends Omit(ConnectedAccountFunds, [...BaseEntityFieldsArray, 'providerType', 'providerId']) {}
